var hostname =
  typeof window !== "undefined" &&
  window &&
  window.location &&
  window.location.hostname;
let host = hostname; // hostname.indexOf('www.') && hostname || hostname.replace('www.', '');

const siteDomains = require("./siteDomains");
var siteUrl = "";
let reCaptchaSiteKey = "6LeNJOgUAAAAAIT0SNI-gQghkg_qPjo4kQK4zAfa";

if (host) {
  let siteDomainData = siteDomains.find((o) => o.siteDomain === host);
  if (siteDomainData) {
    // console.log("siteDomain found for recaptcha siteKey", siteDomainData);
    reCaptchaSiteKey = siteDomainData.siteKey;
  } else {
    //console.log("siteDomain not found, shifting hostname by 1", host);
    let domainParts = host.split(".");
    while (domainParts.length > 2) {
      let subdomain = domainParts.shift();
    }
    host = domainParts.join(".");
    siteDomainData = siteDomains.find((o) => o.siteDomain === host);
    if (siteDomainData) {
      reCaptchaSiteKey = siteDomainData.siteKey;
      //console.log("siteDomain found for recaptcha siteKey", siteDomainData);
    } else {
      // console.log(
      //"siteDomain not found, assuming pool-i for recaptcha siteKey",
      // host
      // );
    }
  }
}

if (hostname) {
  siteUrl = window.location.origin;
}

if (siteUrl === "") {
  //  console.log("Not configured");
  siteUrl = "http://payvibe.com";
}

var appConfig = {
  // dev mode to mock async data for instance
  DEV_MODE: false,
  // When you need some kind "console spam" to debug
  DEBUG_ENABLED: true,
  // fake delay to mock async
  FAKE_ASYNC_DELAY: 1000,

  PUSHER_EVENT: "inv-event",
  PUSHER_CHANNEL: "payvibe-channel",
  appName: "DDB Site Panel",
  helloWord: "Hello",
  currentView: "home",

  // connection status text references

  connectionStatus: {
    online: "online",
    disconnected: "disconnected",
  },
  // eaningGraph config
  earningGraph: {
    data: {
      API: "api/earnigGraphData",
    },
  },
  teamMates: {
    data: {
      API: "api/teamMates",
    },
  },

  // userInfos config
  userInfos: {
    data: {
      // API: 'http://192.168.1.15:8081/v1/login'
      // API: 'api/userInfos'
    },
  },

  app: {
    port: "3027",
    ip: "192.168.1.16",
  },
  site: {
    //siteId: "5fa5d2e95e57bb17f40fa62b5e95aada",
    siteId: "",
    // secret_key: "",
      secret_key: "BWO3kYv7GSX1PZcg0xFcUTnA/toV13wfeAinqGcDIsA=",
  //secret_key: "b6TMybeqwQwovyQe4Gfy8i55Q69yhQwt8awehqsSz1M=",
   //secret_key: 'qW9hV53Wl6RgpfJzDM95HiFlp5YC6EJt5+klJrhgaEk=',
    // secret_key: 'aF3WyMRoiRjEB2bZqzY0b7kblr/Z+4y2hwP9HzLNdaE=',
    siteurl: siteUrl,
  },
  reCaptcha: {
    siteKey: reCaptchaSiteKey,
  },
  api: {
    //url: 'http://192.168.1.79/payvive-api/v1/',
    //url: 'http://127.0.0.1:8000/v1/',
     //url: "https://ddb-api.dealopia.com/v1/",
  //url: "http://apistaging.stpi.com/v1/",
 //url: "http://api-payvibe2023.stpi.com/v1/",
 // url: "https://payvibe-apiv2.dealopia.com/v1/",
  url: "https://payvibe-apiv2-2024.dealopia.com/v1/",
  },
};

module.exports = appConfig;



// WEBPACK FOOTER //
// ./appConfig.js